define(function(require, exports, module) {
    'use strict';

    var config = require('Cloud/config');
    const { extInfo } = require('lib/extInfo');

    /**
     * Библиотека для получения иконок файлов и папок.
     * @namespace
     */
    var icons = {
        /**
         * Иконка неизвестных файлов.
         * @type {string}
         */
        ICON_UNKNOWN: 'unknown',

        /**
         * Иконка обычной папки.
         * @type {string}
         */
        ICON_FOLDER: 'folder',

        /**
         * Иконка зараженных файлов.
         * @type {string}
         */
        ICON_VIRUS: 'virus',

        /**
         * Хэш иконок по известным расширениям файлов.
         * @type {Object}
         */
        _fileIconHash: Object.create(null),

        /**
         * Хэш иконок по известным типам папок.
         * @type {Object}
         */
        _folderIconHash: Object.assign(Object.create(null), {
            storage: 'folder',
            invites: 'folder',
            folder: 'folder',

            'camera-upload': 'folder-camera',
            'folder-camera': 'folder-camera',

            mounted: 'folder-mounted',
            'domain-folder': 'folder-mounted',
            'folder-mounted': 'folder-mounted',

            shared: 'folder-shared',
            'folder-shared': 'folder-shared',

            'folder-virus': 'folder-virus',
        }),

        /**
         * Возвращает хэш расширений файлов, доступных для просмотра
         * или редактирования через Microsoft Office Online.
         * @returns {Object}
         */
        _getMsooExtsHash: function() {
            var hash = Object.create(null);
            var editors = config.get('EDITORS');

            if (Array.isArray(editors)) {
                var msoo = editors.find(function(editor) {
                    return editor.id === 'office';
                });

                if (msoo) {
                    // В RB слоте 10169 находится JSON со списком расширений
                    // для просмотра и редактирования через Microsoft Office Online.
                    var exts = [msoo.view_extensions, msoo.edit_extensions];

                    exts.forEach(function(exts) {
                        if (Array.isArray(exts)) {
                            exts.forEach(function(ext) {
                                hash[ext] = true;
                            });
                        }
                    });
                }
            }

            return hash;
        },

        _makeHash: function() {
            var exts = extInfo.getAll();
            var hash = icons._fileIconHash;
            var msooHash = icons._getMsooExtsHash();

            Object.keys(exts).forEach(function(ext) {
                var data = exts[ext];
                var msIcon = data.msIcon;

                if (msIcon && msooHash[ext]) {
                    // Если пользователю доступен для просмотра
                    // или редактирования Microsoft Office Online,
                    // то используем соответствующие иконки файлов.
                    hash[ext] = msIcon;
                } else {
                    hash[ext] = data.subKind;
                }
            });
        },

        /**
         * Возвращает название иконки, соответствующее расширению файла.
         * @param {string} extension – расширение файла
         * @returns {string}
         */
        getFileIcon: function(extension) {
            var ext = String(extension).toLowerCase();
            var hash = icons._fileIconHash;
            var icon = hash[ext];

            if (!icon) {
                icon = icons.ICON_UNKNOWN;
            }

            return icon;
        },

        /**
         * Возвращает название иконки, соответствующее типу папки.
         * @param {string} type – тип папки (item.subKind)
         * @returns {string}
         */
        getFolderIcon: function(type) {
            var hash = icons._folderIconHash;
            var icon = hash[type];

            if (!icon) {
                icon = icons.ICON_FOLDER;
            }

            return icon;
        },

        /**
         * Возвращает название иконки, соответствующее типу папки или расширению файла.
         * @param {Object} item – {ext, subKind, virus_scan, isFolder}
         * @returns {string}
         */
        getItemIcon: function(item) {
            var icon;

            if (!item) {
                icon = icons.ICON_UNKNOWN;
            } else if (item.virus_scan === 'fail' || item.virusScan === 'fail') {
                icon = icons.ICON_VIRUS;
            } else if (item.isFolder) {
                if (item.kind === 'camera-upload') {
                    icon = icons.getFolderIcon(item.kind);
                } else {
                    icon = icons.getFolderIcon(item.subKind);
                }
            } else {
                icon = icons.getFileIcon(item.ext);
            }

            return icon;
        },
    };

    icons._makeHash();

    module.exports = icons;
});
